import { InjectionToken, type ValueProvider } from '@angular/core';

export const SUPPORT_EMAIL_ADDRESS = new InjectionToken('Support E-mailaddress', {
  factory: () => 'support@reconcept.nl',
});

export function provideSupportEmailAddress(emailAddress: string): ValueProvider {
  return { provide: SUPPORT_EMAIL_ADDRESS, useValue: emailAddress };
}
